import React, {Component, Fragment} from 'react'
import {Card, Button, Col} from "react-bootstrap";
import SVG from "react-inlinesvg";

import icnChevronRigth from '../../../../assets/svg/actions/icn-chevron-rigth-8px-13px.svg';
import SelectFilter from "../../../ui/select/SelectFilter";
import SelectSearch from "../../../ui/select/SelectSearch";
import '../../../../assets/sass/pages/sidebar-filter.scss';
import SimpleScrollbar from "../../../ui/custom_scrollbars/SimpleScrollbar";
import SelectButtons from "../../../ui/select/SelectButtons";
import SliderRange from "../../../ui/Slider/SliderRange";
import {gql, useQuery} from "@apollo/client";
import Tools from "../../../../Tools";
import classes from 'classnames';
import {userSignIn} from "../../../../store/actions/AuthActions/SignInActions";
import {connect} from "react-redux";
import {clearTalentSearchFilters, setCompetitionsFilter, setPerformanceFilter, setPerformanceGroupFilters, setSeasonsFilter} from "../../../../store/actions/Dashboard/TalentSearch/TalentSearchActions";

const Types = {
    NUMBER_SLIDER: "NUMBER_SLIDER",
    TEXT_DROPDOWN: "text-dropdown",
    TOGGLE_SELECTOR: "TOGGLE_SELECTOR",
    DATE: "date",

};

class TalentSearchFilters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menuIsOpen: null,
        };
    }

    refList = [];
    select = React.createRef();


    loanOptions = [
        {value: 'both', label: 'Both'},
        {value: 'on-loan', label: 'On Loan'},
        {value: 'no-loan', label: 'No Loan'},
    ];
    AFSOptions = [
        {value: 'avg', label: 'Avg'},
        {value: 'fast', label: 'Fast'},
        {value: 'swift', label: 'Swift'},
    ];
    AGSOptions = [
        {value: 'avg', label: 'Avg'},
        {value: 'good', label: 'Good'},
        {value: 'superb', label: 'Superb'},
    ];
    CBAOptions = [
        {value: 'cool', label: 'Cool'},
        {value: 'balanced', label: 'Balanced'},
        {value: 'aggressive', label: 'Aggressive'},
    ];

    // state = {
    //     seasons: [
    //         {key: 0, value: 'all', label: "All Seasons Till Date"},
    //         {key: 1, value: 'last-season', label: "Last Season"},
    //         {key: 2, value: 'current-season', label: "Current Season"},
    //         {key: 3, value: '2017-18', label: "2017-18"},
    //         {key: 4, value: '2016-17', label: "2016-17"},
    //         {key: 5, value: '2015-16', label: "2015-16"},
    //         {key: 6, value: '2014-15', label: "2014-15"},
    //         {key: 7, value: '2013-14', label: "2013-14"},
    //     ],
    //     competition: [
    //         {key: 0, value: 'all', label: "All Competitions"},
    //         {key: 1, value: 'a-league', label: "A-League"},
    //         {key: 2, value: 'série-a', label: "Série A"},
    //         {key: 3, value: 'super-league', label: "Super League"},
    //         {key: 4, value: 'english-premier-league-epl', label: "English Premier League (EPL)"},
    //         {key: 5, value: 'ligue-1', label: "Ligue 1"},
    //         {key: 6, value: 'asb-premiership', label: "ASB Premiership"},
    //     ],
    //     general_details: [
    //         {key: 0, value: 'age', label: "Age", type: Types.NUMBER_SLIDER, order: 1},
    //         {key: 2, value: 'height', label: "Height", type: Types.NUMBER_SLIDER, order: 2},
    //         {key: 3, value: 'weight', label: "Weight", type: Types.NUMBER_SLIDER, order: 3},
    //         {key: 4, value: 'playing-position', label: "Playing Position", type: Types.TEXT_DROPDOWN, order: 4},
    //         {key: 5, value: 'market-value', label: "Market Value", type: Types.NUMBER_SLIDER, order: 5},
    //         {key: 6, value: 'passport-country', label: "Passport Country", type: Types.TEXT_DROPDOWN, order: 6},
    //         {key: 7, value: 'loan', label: "Loan", type: Types.TOGGLE_SELECTOR, toggle_options: this.loanOptions, order: 7},
    //         {key: 8, value: 'contract-expiration', label: "Contract Expiration", type: Types.DATE, order: 8},
    //     ],
    //     playing_position: [
    //         {key: 0, value: 'option-1', label: "Option 1"},
    //         {key: 1, value: 'option-2', label: "Option 2"},
    //         {key: 2, value: 'option-3', label: "Option 3"}
    //     ],
    //     passport_country: [
    //         {key: 0, value: 'all', label: "All Countries"},
    //         {key: 1, value: 'albania', label: "Albania"},
    //         {key: 2, value: 'algeria', label: "Algeria"},
    //         {key: 3, value: 'angola', label: "Angola"},
    //         {key: 4, value: 'antigua-and-barbuda', label: "Antigua and Barbuda"},
    //         {key: 5, value: 'argentina', label: "Argentina"},
    //         {key: 6, value: 'australia', label: "Australia"},
    //     ],
    //     attacking: [
    //         {key: 0, value: 'shots-accuracy', label: "Shots Accuracy", type: Types.NUMBER_SLIDER, order: 1},
    //         {key: 1, value: 'assists', label: "Assists", type: Types.NUMBER_SLIDER, order: 2},
    //         {key: 2, value: 'big-chances-created', label: "Big Chances Created", type: Types.NUMBER_SLIDER, order: 3},
    //         {key: 3, value: 'key-passes', label: "Key Passes", type: Types.NUMBER_SLIDER, order: 4},
    //         {key: 4, value: 'short-passing-accuracy', label: "Short Passing Accuracy", type: Types.NUMBER_SLIDER, order: 5},
    //         {key: 5, value: 'duels-won', label: "Duels Won", type: Types.NUMBER_SLIDER, order: 6},
    //         {key: 6, value: 'ariel-duels-won', label: "Ariel Duels Won", type: Types.NUMBER_SLIDER, order: 7},
    //         {key: 7, value: 'crossing-accuracy', label: "Crossing Accuracy", type: Types.NUMBER_SLIDER, order: 8},
    //         {key: 8, value: 'corner-kicks-accuracy', label: "Corner Kicks Accuracy", type: Types.NUMBER_SLIDER, order: 9},
    //         {key: 9, value: 'dribbles-won', label: "Dribbles Won", type: Types.NUMBER_SLIDER, order: 10},
    //     ],
    //     defense: [
    //         {key: 0, value: 'tackles-won', label: "Tackles Won", type: Types.NUMBER_SLIDER, order: 1},
    //         {key: 1, value: 'clean-sheets', label: "Clean Sheets", type: Types.NUMBER_SLIDER, order: 2},
    //         {key: 2, value: 'long-passing-accuracy', label: "Long Passing Accuracy", type: Types.NUMBER_SLIDER, order: 3},
    //         {key: 3, value: 'successful-blocks', label: "Successful Blocks", type: Types.NUMBER_SLIDER, order: 4},
    //         {key: 4, value: 'clearance-accuracy', label: "Clearance Accuracy", type: Types.NUMBER_SLIDER, order: 5},
    //         {key: 5, value: 'successful-interceptions', label: "Successful Interceptions", type: Types.NUMBER_SLIDER, order: 6},
    //     ],
    //     discipline: [
    //         {key: 0, value: 'fouls-committed', label: "Fouls Committed", type: Types.NUMBER_SLIDER, max: 50, order: 1},
    //         {key: 1, value: 'yellow-card', label: "Yellow Card", type: Types.NUMBER_SLIDER, max: 20, order: 2},
    //         {key: 2, value: 'red-card', label: "Red Card", type: Types.NUMBER_SLIDER, order: 3},
    //     ],
    //     movement: [
    //         {key: 0, value: 'sprint-speed', label: "Sprint Speed", type: Types.NUMBER_SLIDER, max: 30, order: 1},
    //         {key: 1, value: 'reaction-time', label: "Reaction Time", type: Types.TOGGLE_SELECTOR, toggle_options: this.AFSOptions, order: 2},
    //         {key: 2, value: 'agility', label: "Agility", type: Types.TOGGLE_SELECTOR, toggle_options: this.AFSOptions, order: 3},
    //         {key: 3, value: 'balance', label: "Balance", type: Types.TOGGLE_SELECTOR, toggle_options: this.AGSOptions, order: 4},
    //     ],
    //     goal_keeping: [
    //         {key: 0, value: 'diving-score', label: "Diving Score", type: Types.NUMBER_SLIDER, order: 1},
    //         {key: 1, value: 'handling', label: "Handling", type: Types.TOGGLE_SELECTOR, toggle_options: this.AFSOptions, order: 2},
    //         {key: 2, value: 'positioning', label: "Positioning", type: Types.TOGGLE_SELECTOR, toggle_options: this.AGSOptions, order: 3},
    //         {key: 3, value: 'reflexes', label: "Reflexes", type: Types.TOGGLE_SELECTOR, toggle_options: this.AGSOptions, order: 4},
    //         {key: 4, value: 'kicking-accuracy', label: "Kicking Accuracy", type: Types.NUMBER_SLIDER, order: 5},
    //     ],
    //     mental_score: [
    //         {key: 1, value: 'aggression', label: "Aggression", type: Types.TOGGLE_SELECTOR, toggle_options: this.CBAOptions, order: 1},
    //         {key: 2, value: 'positioning', label: "Positioning", type: Types.TOGGLE_SELECTOR, toggle_options: this.AGSOptions, order: 2},
    //         {key: 3, value: 'composure', label: "Composure", type: Types.TOGGLE_SELECTOR, toggle_options: this.AGSOptions, order: 3},
    //         {key: 4, value: 'vision', label: "Vision", type: Types.TOGGLE_SELECTOR, toggle_options: this.AGSOptions, order: 4},
    //         {key: 5, value: 'marking', label: "Marking", type: Types.TOGGLE_SELECTOR, toggle_options: this.AGSOptions, order: 5},
    //     ],
    //     other: [
    //         {key: 0, value: 'option-1', label: "Option 1"},
    //         {key: 1, value: 'option-2', label: "Option 2"},
    //         {key: 2, value: 'option-3', label: "Option 3"}
    //     ],
    //     menuIsOpen: null
    // };


    select_attr = {
        "playing-position": {
            searchPlaceholder: "Select attributes",
        },
        "passport-country": {
            searchPlaceholder: "Search Conuntry",
        }
    };

    onMenuOpen = () => {
        if (this.state.menuIsOpen === false)
            this.setState({
                menuIsOpen: null,
            })
    };
    openAside = () => {
        this.props.openAside()
    };

    onScroll = (e) => {
        if (this.state.menuIsOpen == null)
            this.setState({
                menuIsOpen: false,
            })
    };

    onDynamicChange = (name, value) => {
        this.setState({
            "form": {
                ...this.state.form,
                [name]: value
            }
        })
    };
    onDynamicLoad = (name, value) => {
        this.defaultForm = {
            ...this.defaultForm,
            [name]: value
        };

        this.setState({
            "form": {
                ...this.state.form,
                ...this.defaultForm
            }
        })
    };
    onDynamicDestroy = (name) => {
        const form = this.state.form;
        if (form) {
            form[name] = null;
            this.setState({
                "form": form
            })
        }
    };

    dynamicItems = (group) => {
        const {performance} = this.props;

        return group.options
            .filter(filter => performance[group.name] && performance[group.name][filter.value.name])
            .map(filter => ({...filter, props: filter.value, groupName: group.name, value: performance[group.name][filter.value.name]}))
            .map(filter => {
                switch (filter.props.type) {
                    case Types.NUMBER_SLIDER:
                        return this.renderNumberSlider(filter);
                    case Types.TEXT_DROPDOWN:
                        return this.renderTextDropdown(filter);
                    case Types.TOGGLE_SELECTOR:
                        return this.renderToggleSelector(filter);
                    case Types.DATE:
                        return this.renderDate(filter);
                }
            });
    };
    onButtonSelectSelected = (e, option, name) => {
        this.onDynamicChange(name, option.value);
    };
    onSliderChange = (groupName, filterName, [from, to]) => {
        const value = {from: from, to: to};
        this.onDynamicChange(filterName, value);
    };

    handlePerformanceFiltersChange = (data) => {
        const groupName = data.name;
        const filters = data.options.filter(option => option.checked);

        const {setPerformanceGroupFilters} = this.props;
        setPerformanceGroupFilters(groupName, filters);
    };

    refCallback = (ref) => {
        this.refList.push(ref);
    };

    resetAll = (e) => {
        e.preventDefault();
        const {clearFilters} = this.props;
        clearFilters();

        this.refList.map((element, key) => {
            element.clearSelected();
        });
    };

    renderNumberSlider = (filter) => {
        const {groupName, value, props: filterProps} = filter;
        const {name, label, min, max} = filterProps;
        const {from, to} = value;

        return (
            <div className="filter-item">
                <h5>{label}</h5>
                <SliderRange name={name} min={min} max={max} from={from ?? min} to={to ?? max} onSliderChange={({}, [from, to]) => this.handlePerformanceFilterChange(groupName, name, {from: from, to: to})}/>
            </div>
        );
    };

    renderTextDropdown = element => {
        return (
            <div className="filter-item select-position">
                <h5>{element.label}</h5>
                <SelectSearch
                    name={element.value}
                    type="sm"
                    color="flat"
                    placeholder="Select attributes"
                    searchPlaceholder={this.select_attr[element.value].searchPlaceholder}
                    menuPlacement="auto"
                    arrowSidePlacement="right"
                    menuIsOpen={this.state.menuIsOpen}
                    onMenuOpen={this.onMenuOpen}
                    options={this.state[element.value.replace('-', '_')]}
                    onDoneClick={this.handlePerformanceFiltersChange}
                    selected="true"
                    showTag="true"
                    filterButtons={{done: true, cancel: true}}
                    menuPosition="true"
                />
            </div>
        );
    };

    renderToggleSelector = filter => {
        const {groupName, value, props: filterProps} = filter;
        const {name, label, options} = filterProps;
        const selectOptions = options.map(option => ({value: option, label: option}));
        const defaultValue = {label: value, value: value, key: value};
        return (
            <div className="filter-item">
                <h5>{label}</h5>
                <SelectButtons
                    name={name}
                    size="sm"
                    options={selectOptions}
                    defaultValue={value}
                    onSelect={(event, option) => this.handlePerformanceFilterChange(groupName, name, option.value)}
                    onLoad={this.onDynamicLoad}
                    onDestroy={this.onDynamicDestroy}
                    split={true}
                    darkmode={true}
                />
            </div>
        );
    };

    renderDate = element => {
        return (
            <></>
        );
    };

    render = () => {
        return (
            <Card className="aside-filter">
                <Card.Header>
                    <div className="close-filter">
                        <Button variant="light" onClick={this.openAside}>
                            <SVG src={icnChevronRigth}/>
                        </Button>
                        <span>Close</span>
                    </div>
                    <div className="header-filter">
                        <h3 className="m-0">Filters</h3>
                        <a href="#" onClick={this.resetAll}>Reset All</a>
                    </div>
                </Card.Header>
                <Card.Body className="p-0">
                    <SimpleScrollbar maxHeight="calc(100vh - 123px)" className="p-3" onScroll={this.onScroll}>
                        {this.renderFilters()}
                    </SimpleScrollbar>
                </Card.Body>
            </Card>
        );
    };

    renderFilters = () => {
        return (
            <Fragment>
                {this.renderGlobalGroup()}
                <div className="filter-seperator"/>
                {this.renderPerformanceGroups()}
            </Fragment>
        )
    };

    renderGlobalGroup = () => {
        const {seasonsOptions, competitionOptions, setSeasonsFilter, setCompetitionsFilter} = this.props;
        const {onMenuOpen, refCallback} = this;
        const {menuIsOpen} = this.state;

        return (
            <div className="filter-group">
                <h4>Global</h4>
                <TalentSearchFilters.FilterItem
                    className="select-position"
                    subtitle="Year/Season"
                    name="seasons"
                    placeholder="All Seasons Till Date"
                    options={seasonsOptions}
                    menuPlacement="auto"
                    menuIsOpen={menuIsOpen}
                    onMenuOpen={onMenuOpen}
                    onSelectDoneClick={(filter) => setSeasonsFilter(filter.options)}
                    refCallback={refCallback}
                    showTag="true"
                />

                <TalentSearchFilters.FilterItem
                    className="select-position"
                    subtitle="Competition"
                    name="competition"
                    placeholder="All Competitions"
                    options={competitionOptions}
                    menuPlacement="auto"
                    menuIsOpen={menuIsOpen}
                    onMenuOpen={onMenuOpen}
                    onSelectDoneClick={(filter) => setCompetitionsFilter(filter.options)}
                    refCallback={refCallback}
                    showTag="true"
                />
            </div>
        )
    };

    renderPerformanceGroups = () => {
        const {groups} = this.props;

        return groups.map((filterGroup, index) =>
            <Fragment key={index}>
                {this.renderPerformanceGroup(filterGroup)}
                {index < filterGroup.length - 1 && <div className="filter-seperator"/>}
            </Fragment>
        );
    };

    renderPerformanceGroup = filterGroup => {
        const {title} = filterGroup;

        return (
            <div className="filter-group select-position">
                <h4>{title}</h4>
                {this.renderPerformanceFilterItem(filterGroup)}
                {this.dynamicItems(filterGroup)}
            </div>
        );
    };

    renderPerformanceFilterItem = filterItem => {
        const {title, options, placeholder, showTag, name} = filterItem;
        const {menuIsOpen} = this.state;
        const {onMenuOpen, handlePerformanceFiltersChange, refCallback} = this;

        return (
            <TalentSearchFilters.FilterItem
                title={title}
                name={name}
                options={options}
                placeholder={placeholder}
                showTag={showTag}
                menuIsOpen={menuIsOpen}
                onMenuOpen={onMenuOpen}
                onSelectDoneClick={handlePerformanceFiltersChange}
                refCallback={refCallback}
            />
        );
    };

    handlePerformanceFilterChange = (groupName, filterName, value) => {
        const {setPerformanceFilter} = this.props;
        setPerformanceFilter(groupName, filterName, value);
    };
}

TalentSearchFilters.FilterItem = props => {
    const {options, placeholder, showTag, name, subtitle, menuIsOpen, className} = props;
    const {onMenuOpen, onSelectDoneClick, refCallback} = props;

    return (
        <div className={classes("filter-item", className)}>
            {subtitle && <h5>{subtitle} </h5>}
            <SelectSearch
                ref={refCallback}
                name={name}
                type="sm"
                color="flat"
                placeholder={placeholder}
                menuPlacement="auto"
                arrowSidePlacement="right"
                menuIsOpen={menuIsOpen}
                onMenuOpen={onMenuOpen}
                options={SelectSearch.options(options)}
                onDoneClick={onSelectDoneClick}
                selected="true"
                showTag={showTag}
                filterButtons={{done: true, cancel: true}}
                menuPosition="true"
            />
        </div>
    );
};

const TalentSearchFiltersDataWrapper = props => {
    const query = gql`
        {
            performanceFilters: performanceTypes{
                name
                code
                properties{
                    name
                    code
                    type
                    min
                    max
                    options
                }
            }
            seasonsOptions: seasons{
                name
                id
            }
            competitionOptions: competitions{
                name
                id
            }
        }
    `;

    const seasonsOptionsFormatter = (seasonsOptions) => seasonsOptions?.map((option) => ({value: option.id, label: option.name}));
    const competitionOptionsFormatter = (competitionOptions) => competitionOptions?.map((option) => ({value: option.id, label: option.name}));
    const performanceFiltersFormatter = (performanceFilters) => performanceFilters?.map((filter) => ({
        title: filter.name,
        placeholder: `Select ${filter.name}`,
        name: filter.code,
        options: filter.properties.map((property, index) => {
            let value = {
                name: property.code,
                code: property.code,
                type: property.type === 'number-slider' ? Types.NUMBER_SLIDER :
                    property.type === 'toggle-selector' ? Types.TOGGLE_SELECTOR :
                        '',
            };

            if (property.min || property.max) {
                value.min = property.min ?? 0;
                value.max = property.max ?? 100;
            }

            if (property.options) {
                value.options = property.options;
            }

            return {
                label: property.name,
                value: value,
            };
        }),
    }));

    const {loading, error, data} = useQuery(query);

    if (loading)
        return "Loading";
    else if (error)
        return "Error";

    const performanceFilters = data?.performanceFilters;
    const seasonsOptions = data?.seasonsOptions;
    const competitionOptions = data?.competitionOptions;

    // TODO: reformat;
    return (
        <TalentSearchFilters
            groups={performanceFiltersFormatter(performanceFilters)}
            seasonsOptions={seasonsOptionsFormatter(seasonsOptions)}
            competitionOptions={competitionOptionsFormatter(competitionOptions)}
            {...props}/>
    );
};


const mapStateToProps = state => {
    return {
        performance: state.talentSearch.filters.performance,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setPerformanceFilter: (group, name, value) => dispatch(setPerformanceFilter(group, name, value)),
        setPerformanceGroupFilters: (group, filters) => dispatch(setPerformanceGroupFilters(group, filters)),
        clearFilters: () => dispatch(clearTalentSearchFilters()),
        setSeasonsFilter: (options) => dispatch(setSeasonsFilter(options)),
        setCompetitionsFilter: (options) => dispatch(setCompetitionsFilter(options)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TalentSearchFiltersDataWrapper);
